<script>
import router from '@/router'
import HeadWithLogo from "@/components/HeadWithLogo";

export default {
  components: {HeadWithLogo},
  data(){
    return{
      fullname:""
    }
  },
  mounted() {
    if(localStorage.name){
      this.fullname=localStorage.name
    }
    if(!localStorage.token){
      router.push('/PhoneNumber')
    }
  },
}
</script>
<template>
  <HeadWithLogo/>
  <div class="bg-light-green">
    <div class="row">
      <div class="col-10 col-md-8 mx-auto mt-3">
        <span> فرهیخته گرامی {{ fullname }} </span><br>
        <p class="text-justify">
          اطلاعات شما به صورت کامل ثبت و برای تایید نهایی و معرفی به پلیس امنیت
          عمومی نیروی انتظامی ارسال خواهد شد.
        </p>
      </div>
    </div>
  </div>
</template>
<style>
.mainBox {
  position: fixed;
  width: 480px;
  height: 60px;
  top: 15%;
  left: 50%;
  margin-top: -100px; /* Negative half of height. */
  margin-left: -250px; /* Negative half of width. */

}

.gonbad {
  z-index: -1;
  margin-bottom: -24px;
}

.content-box {
  height: 100%;
  direction: rtl;
  text-align: justify;
  margin-top: 45px;
}
</style>

